export enum ReturnDeliveryChannel {
  CREATE = 'returnDelivery::create',
  EDIT = 'returnDelivery::patch',
  DELETE = 'returnDelivery::delete',
}
